<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <!-- {{sendingSchedule}} -->
        <!-- activeIndex: {{activeIndex}}-->
        <!-- {{formParam}}
        <hr />-->
        <!-- {{formParamScrapeSt}} -->
        <div class="col-md-8">
          <div class="col-md-12 profile-info-left">
            <table class="table">
              <tbody>
                <tr>
                  <td class="text-muted text-left" style="width:30%">Title</td>
                  <th class="text-left">{{ formParamScrapeSt.title }}</th>
                </tr>
                <tr>
                  <td class="text-muted text-left" style="width:30%">
                    Brand/Merek
                  </td>
                  <th class="text-left" ref="brand">
                    <Skeleton :count="1" />
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left" style="width:30%">
                    Media Type
                  </td>
                  <th class="text-left">
                    <span class="badge badge-primary">{{
                      formParamScrapeSt.media_type
                    }}</span>
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Assets Media</td>
                  <th class="text-left">
                    <div
                      v-if="
                        typeof formParamScrapeSt.assets_url != 'undefined' &&
                          formParamScrapeSt.assets_url.length
                      "
                    >
                      <carousel
                        :navigateTo="0"
                        :autoplay="true"
                        :paginationEnabled="false"
                        :perPage="1"
                        :navigationEnabled="true"
                        :centerMode="true"
                        :paginationActiveColor="'#00bddc'"
                        :paginationColor="'#99e8ff'"
                      >
                        <slide
                          v-for="(imgSrc, idx) in formParamScrapeSt.assets_url"
                          data-index="0"
                          :key="idx"
                        >
                          <img
                            v-if="
                              imgSrc.includes('.jpg') ||
                                imgSrc.includes('.jpeg')
                            "
                            style="width: 100%;"
                            :src="imgSrc"
                            alt=""
                          />
                          <video
                            style="width: 100%; height: 100%; overflow: hidden;"
                            v-else-if="imgSrc.includes('.mp4')"
                            controls
                          >
                            <source :src="imgSrc" type="video/mp4" />
                          </video>
                        </slide>
                      </carousel>
                    </div>
                    <div v-else class="card">
                      <div class="card-body">
                        <img
                          style="width:100%;"
                          src="@/assets/placeholder.jpg"
                        />
                      </div>
                    </div>
                    <div
                      style="margin-top:10px;"
                      class="card"
                      v-show="
                        formParamScrapeSt.caption != '' &&
                          formParamScrapeSt.media_type != 'story'
                      "
                    >
                      <div
                        class="card-body"
                        v-html="messageFilter(formParamScrapeSt.caption)"
                      ></div>
                    </div>
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Accounts</td>
                  <th class="text-left" ref="accounts">
                    <Skeleton :count="1" />
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12">
              <label class="col-form-label">
                Publish Options
                <span class="text text-danger">*</span>
              </label>
              <div class="radio">
                <label
                  :style="'margin-left:10px;'"
                  v-for="(row, index) in listSendingOptions"
                  :key="index"
                >
                  <input
                    :id="row.id"
                    type="radio"
                    :value="row.id"
                    v-model="formParam.sending_options"
                    @change="formValidate"
                  />
                  {{ row.label }}
                </label>
              </div>
            </div>
            <div class="col-md-12" v-if="formParam.sending_options == '2'">
              <div class="form-group">
                <label>Time to publish:</label>

                <div class="cal-icon">
                  <datetime
                    :min-datetime="currentDateTimeUTC()"
                    :zone="'local'"
                    :use12-hour="true"
                    input-class="form-control"
                    value-zone="UTC"
                    type="datetime"
                    v-model="sendingSchedule"
                  ></datetime>

                  <!-- <input type="text" class="form-control floating datetimepicker" /> -->
                </div>
                <!-- <span
                    v-if="broadcastParam.sending_schedule!=''"
                >UTC: {{broadcastParam.sending_schedule}}</span>-->
              </div>
            </div>
          </div>
          <scheduler :activeIndex="activeIndex" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import { currentDateTimeUTC } from "@/utils/helper";
import Scheduler from "./scheduler.vue";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Skeleton,
    Scheduler,
    Datetime,
    Carousel,
    Slide
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sendingSchedule: "",
      formParam: {
        sending_options: 1,
        sending_schedule: ""
      },
      listSendingOptions: [
        { id: 1, label: "Now" },
        { id: 2, label: "Schedule" }
        // { id: 3, label: "Send a test" }
      ],
      isLoading: false
    };
  },
  watch: {
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          // console.log("oldValForm3", oldVal);
          // console.log("newValForm3", val);

          this.formParam.is_publish = 1;
          this.formParam.sending_options = val.sending_options;
          this.formParam.sending_schedule = val.sending_schedule;
          this.sendingSchedule = val.sending_schedule;
        }
      },
      deep: true
    },
    sendingSchedule: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          this.formValidate();
        }
      },
      deep: true
    },
    activeIndex: {
      handler: async function(val, oldVal) {
        if (val == 2) {
          // that.getMarketplaceList();
          await this.getLabel();
          this.formValidate();
        }
      },
      deep: true
    }
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.instagramSchedule.formParamScrapeSt;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    formValidate() {
      let newParam = this.formParamScrapeSt;
      newParam.is_publish = 1;
      newParam.sending_options = this.formParam.sending_options;
      newParam.sending_schedule = this.sendingSchedule;

      this.$store.dispatch("instagramSchedule/actFormParamScrapeSt", newParam);
      // console.log("newParamForm3", newParam);
    },

    async getLabel() {
      this.$store
        .dispatch("brand/detail", this.formParamScrapeSt.brand_id) // sesuai kan dengan method di API
        .then(responseDet => {
          var resData = responseDet.data;
          this.$refs.brand.innerHTML = resData.name;
        });

      this.$refs.accounts.innerHTML = "";
      this.formParamScrapeSt.instagram_account_id.forEach((accountId, idx) => {
        this.$store
          .dispatch("instagramAccount/detail", accountId) // sesuai kan dengan method di API
          .then(responseDet => {
            var resData = responseDet.data;
            if (idx > 0) {
              this.$refs.accounts.innerHTML +=
                " <a target='_blank' href='https://instagram.com/" +
                resData.username +
                "' class='badge badge-info'>" +
                resData.username +
                "</a>";
            } else {
              this.$refs.accounts.innerHTML +=
                "<a target='_blank' href='https://instagram.com/" +
                resData.username +
                "' class='badge badge-info'>" +
                resData.username +
                "</a>";
            }
          });
      });
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {},
  name: "form-3"
};
</script>



// WEBPACK FOOTER //
// src/views/instagram/instagramScheduleOfficial/components/form3.vue